import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

document.documentElement.dataset.release = "2026-08-02-firebase-repair";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
